/* Header, mobile drawer, search overlay and cart count.
   Ported from the mockup's assets/js/app.js (section 1); the mockup's local
   search index is replaced by Shopify's own /search. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const header = $('.header');
  if (header) {
    const stuck = () => header.classList.toggle('is-stuck', scrollY > 6);
    addEventListener('scroll', stuck, { passive: true });
    stuck();
  }

  const drawer = $('#mobile-nav');
  const backdrop = $('#backdrop');
  const openBtn = $('#nav-open');
  const closeBtn = $('#nav-close');
  const panel = $('#search-panel');
  const input = $('#search-input');

  const setDrawer = open => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    backdrop?.classList.toggle('is-open', open);
    openBtn?.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) drawer.querySelector('a, button')?.focus();
    else openBtn?.focus();
  };

  let opener = null;
  const setSearch = open => {
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { input.focus(); input.select(); }
    else (opener && opener.offsetParent ? opener : openBtn?.offsetParent ? openBtn : $('#search-open'))?.focus();
  };

  openBtn?.addEventListener('click', () => setDrawer(true));
  closeBtn?.addEventListener('click', () => setDrawer(false));
  backdrop?.addEventListener('click', () => { setDrawer(false); setSearch(false); });
  $$('[data-search-open]').forEach(btn => btn.addEventListener('click', () => {
    opener = btn;
    if (drawer?.classList.contains('is-open')) setDrawer(false);
    setSearch(true);
  }));
  $('#search-close')?.addEventListener('click', () => setSearch(false));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (panel?.classList.contains('is-open')) setSearch(false);
      if (drawer?.classList.contains('is-open')) setDrawer(false);
    }
    if (e.key === '/' && !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) {
      e.preventDefault(); setSearch(true);
    }
  });

  /* Cart count: server-rendered on load, refreshed from /cart.js when the page
     comes back from the back/forward cache. */
  const paintCount = n => $$('.js-cart-count').forEach(el => {
    el.textContent = n;
    el.hidden = !n;
  });
  const refreshCount = () => fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(r => r.json()).then(c => paintCount(c.item_count)).catch(() => {});
  addEventListener('pageshow', e => { if (e.persisted) refreshCount(); });
  document.addEventListener('cart:refresh', refreshCount);
})();
